<div class="select" tabindex="1" [ngClass]="{'disabled': disabled}">
    <ng-container *ngFor="let item of dropDownData;let i = index">
        <input class="selectopt" name="test" (change)="onSelect($event)" [value]="item.value" type="radio" [attr.id]="'opt'+(i+1)" [checked]="i == 0" [disabled]="disabled">
        <label [attr.for]="'opt'+(i+1)" class="option">{{item.name}}</label>
    </ng-container>

  
</div>